import type {
  GoogleDriveBrowseResponse,
  GoogleDriveDocumentContent,
  GoogleDriveFolderCountResponse,
  GoogleDriveItem,
} from "@/types";
import { api } from "../api";

export const googleDriveService = {
  listFiles: (folderId?: string) => {
    const params = folderId ? `?folder_id=${encodeURIComponent(folderId)}` : "";
    return api.get<GoogleDriveBrowseResponse>(`/google-drive/files${params}`);
  },

  getFile: (fileId: string) => api.get<GoogleDriveItem>(`/google-drive/files/${fileId}`),

  countFolderItems: (folderId: string, recursive: boolean = false) =>
    api.get<GoogleDriveFolderCountResponse>(`/google-drive/files/${folderId}/count?recursive=${recursive}`),

  searchFiles: (query: string) => api.get<GoogleDriveItem[]>(`/google-drive/search?q=${encodeURIComponent(query)}`),

  downloadDocument: (fileId: string) => api.post<GoogleDriveDocumentContent>(`/google-drive/download/${fileId}`),
};
